const CURRENCY = 'BRL';

function generateId() {
  return Date.now().toString(36) + Math.random().toString(36).slice(2);
}

function getSessionId() {
  let id = sessionStorage.getItem('sp_session_id');
  if (!id) {
    id = generateId();
    sessionStorage.setItem('sp_session_id', id);
  }
  return id;
}

function getClientId() {
  let id = localStorage.getItem('sp_client_id');
  if (!id) {
    id = generateId();
    localStorage.setItem('sp_client_id', id);
  }
  return id;
}

function push(event) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    session_id: getSessionId(),
    client_id: getClientId(),
    ...event,
  });
}

function pushEcommerce(event) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ ecommerce: null });
  push(event);
}

function formatItem(plan, quantity = 1) {
  return {
    item_id: String(plan.code),
    item_name: plan.name,
    item_brand: plan.provider_code,
    item_category: 'Seguro Viagem',
    price: parseFloat(plan.price_with_coupon_discount || (plan.adult && plan.adult.price)) || 0,
    quantity: parseInt(quantity, 10) || 1,
  };
}

const dataLayer = {
  /**
   * Disparo: SPA muda de rota / página carrega.
   * Obrigatório para calcular: taxa de conversão para busca, conversão checkout, conversão upsell.
   * @param {'home'|'search_results'|'checkout'|'checkout_upsell'|'checkout_segurados'|'checkout_pagamento'|'checkout_confirmacao'} pageType
   * @param {string} [pageTitle]
   */
  pageView(pageType, pageTitle) {
    push({
      event: 'page_view',
      page_type: pageType,
      page_title: pageTitle || document.title,
      page_path: window.location.pathname + window.location.search,
    });
  },

  /**
   * Disparo: usuário submete formulário de busca.
   * @param {string} destination
   * @param {string} beginDate  YYYY-MM-DD
   * @param {string} endDate    YYYY-MM-DD
   * @param {number} travelers
   */
  searchSubmitted(destination, beginDate, endDate, travelers) {
    push({
      event: 'sp_search_submitted',
      search_term: destination,
      travel_begin_date: beginDate,
      travel_end_date: endDate,
      travelers: parseInt(travelers, 10) || 1,
    });
  },

  /**
   * Disparo: lista de planos renderizada após busca.
   * @param {Array}  plans
   * @param {string} destination
   */
  viewItemList(plans, destination) {
    pushEcommerce({
      event: 'view_item_list',
      ecommerce: {
        currency: CURRENCY,
        item_list_name: `Resultados: ${destination}`,
        items: plans.map((plan, index) => ({ ...formatItem(plan), index })),
      },
    });
  },

  /**
   * Disparo: usuário abre detalhes/modal de um plano específico.
   * @param {Object} plan
   */
  viewItem(plan) {
    pushEcommerce({
      event: 'view_item',
      ecommerce: {
        currency: CURRENCY,
        value: parseFloat(plan.price_with_coupon_discount || (plan.adult && plan.adult.price)) || 0,
        items: [formatItem(plan)],
      },
    });
  },

  /**
   * Disparo: usuário clica em "Selecionar".
   * @param {Object} plan
   * @param {number} quantity  número de segurados
   */
  addToCart(plan, quantity = 1) {
    const item = formatItem(plan, quantity);
    pushEcommerce({
      event: 'add_to_cart',
      ecommerce: {
        currency: CURRENCY,
        value: item.price * item.quantity,
        items: [item],
      },
    });
  },

  /**
   * Disparo: primeira etapa do checkout carregada.
   * @param {Object} plan
   * @param {number} quantity
   */
  beginCheckout(plan, quantity = 1) {
    const item = formatItem(plan, quantity);
    pushEcommerce({
      event: 'begin_checkout',
      ecommerce: {
        currency: CURRENCY,
        value: item.price * item.quantity,
        items: [item],
      },
    });
  },

  /**
   * Disparo: usuário seleciona / troca forma de pagamento.
   * @param {Object} plan
   * @param {number} quantity
   * @param {'credit_card'|'pix'|'boleto'} paymentMethod
   * @param {number} installments
   */
  addPaymentInfo(plan, quantity = 1, paymentMethod, installments = 1) {
    const item = formatItem(plan, quantity);
    pushEcommerce({
      event: 'add_payment_info',
      ecommerce: {
        currency: CURRENCY,
        value: item.price * item.quantity,
        payment_type: paymentMethod,
        installments: parseInt(installments, 10) || 1,
        items: [item],
      },
    });
  },

  /**
   * Disparo: botão "Pagar" clicado — antes de saber o resultado.
   * @param {Object}      order          { id, grandTotal, coupon?, discount? }
   * @param {Object}      plan
   * @param {number}      quantity
   * @param {string}      paymentMethod
   * @param {number}      installments
   * @param {string|null} errorCode      null se sucesso; ex: 'declined', 'timeout', '3ds_failed'
   */
  purchaseAttempted(order, plan, quantity = 1, paymentMethod, installments = 1, errorCode = null) {
    const item = formatItem(plan, quantity);
    pushEcommerce({
      event: 'sp_purchase_attempted',
      payment_type: paymentMethod,
      installments: parseInt(installments, 10) || 1,
      error_code: errorCode,
      ecommerce: {
        currency: CURRENCY,
        transaction_id: String(order.id),
        value: parseFloat(order.grandTotal) || item.price * item.quantity,
        coupon: order.coupon || undefined,
        items: [item],
      },
    });
  },

  /**
   * Disparo: compra confirmada.
   * @param {Object}  order   { id, grandTotal, coupon?, discount? }
   * @param {Object}  plan
   * @param {number}  quantity
   * @param {string}  paymentMethod
   * @param {number}  installments
   */
  purchase(order, plan, quantity = 1, paymentMethod, installments = 1) {
    const item = formatItem(plan, quantity);
    pushEcommerce({
      event: 'purchase',
      ecommerce: {
        currency: CURRENCY,
        transaction_id: String(order.id),
        value: parseFloat(order.grandTotal) || item.price * item.quantity,
        coupon: order.coupon || undefined,
        discount: parseFloat(order.discount) || 0,
        payment_type: paymentMethod,
        installments: parseInt(installments, 10) || 1,
        items: [item],
      },
    });
  },

  /**
   * Disparo: usuário avança ou volta entre etapas do checkout.
   * @param {'upsell'|'segurados'|'pagamento'|'confirmacao'} stepName
   * @param {'forward'|'backward'} direction
   */
  checkoutStepView(stepName, direction = 'forward') {
    push({
      event: 'sp_checkout_step_view',
      step_name: stepName,
      direction,
    });
  },

  /**
   * Disparo: tela de upsell exibida ao usuário.
   * @param {Object} basePlan     plano original selecionado
   * @param {Object} upgradePlan  plano sugerido como upgrade
   */
  upsellViewed(basePlan, upgradePlan) {
    push({
      event: 'upsell_viewed',
      base_plan_id: String(basePlan.code),
      base_plan_name: basePlan.name,
      upgrade_plan_id: String(upgradePlan.code),
      upgrade_plan_name: upgradePlan.name,
      upgrade_price_delta: parseFloat(
        (upgradePlan.price_with_coupon_discount || (upgradePlan.adult && upgradePlan.adult.price)) -
        (basePlan.price_with_coupon_discount || (basePlan.adult && basePlan.adult.price))
      ) || 0,
    });
  },

  /**
   * Disparo: usuário aceita o upgrade de plano.
   * @param {Object} upgradePlan
   * @param {number} quantity
   */
  upsellAccepted(upgradePlan, quantity = 1) {
    const item = formatItem(upgradePlan, quantity);
    pushEcommerce({
      event: 'upsell_accepted',
      ecommerce: {
        currency: CURRENCY,
        value: item.price * item.quantity,
        items: [item],
      },
    });
  },

  /**
   * Disparo: usuário rejeita o upgrade e continua com plano original.
   * @param {Object} basePlan
   */
  upsellRejected(basePlan) {
    push({
      event: 'upsell_rejected',
      base_plan_id: String(basePlan.code),
      base_plan_name: basePlan.name,
    });
  },

  /**
   * Disparo: usuário aplica filtros na listagem.
   * @param {Object} filters  { providers: [], coverage: number, benefits: [] }
   * @param {number} resultsCount
   */
  applyFilter(filters, resultsCount) {
    push({
      event: 'apply_filter',
      filter_providers: (filters.providers && filters.providers.join(',')) || '',
      filter_coverage: filters.coverage || null,
      filter_benefits: (filters.benefits && filters.benefits.join(',')) || '',
      results_count: resultsCount,
    });
  },

  /**
   * Disparo: usuário aplica cupom de desconto.
   * @param {string}  couponCode
   * @param {boolean} success
   */
  applyPromo(couponCode, success) {
    push({
      event: 'apply_promo',
      coupon_code: couponCode,
      coupon_success: success,
    });
  },

  /**
   * Disparo: usuário abre comparativo de planos.
   * @param {Array<string>} planNames
   */
  comparePlans(planNames) {
    push({
      event: 'compare_plans',
      compared_plans: planNames.join(' vs '),
    });
  },

  /**
   * Push genérico para eventos legados no formato category/action/label (substitui gtmTrigger).
   * @param {string} event
   * @param {string} category
   * @param {string} action
   * @param {string} [label]
   */
  genericEvent(event, category, action, label) {
    push({
      event,
      event_category: category,
      event_action: action,
      event_label: label,
    });
  },

  /**
   * Push direto ao dataLayer — para eventos customizados sem mapeamento específico.
   * Adiciona session_id e client_id automaticamente.
   * @param {Object} data
   */
  raw(data) {
    push(data);
  },
};

export default dataLayer;



// WEBPACK FOOTER //
// ./src/utils/dataLayer.js